import React, { Component } from "react"
import PatientFolderDeleteModal from "./PatientFolderDeleteModal"

import { Row, Col, Button } from "antd"


class PatientFolderActions extends Component {
    constructor(props) {
        super(props)

        this.state = {
            showDeleteModal: false,
        }
    }

    atleastOneSelected = () => this.props.selectedRows?.length >= 1

    render() {
        return (
            <Row type="flex" gutter={2}>
                <Col span={2.5}>
                    <Button
                        onClick={this.props.handleCancelSelect}
                        disabled={!this.atleastOneSelected()}
                        style={{ visibility: this.atleastOneSelected() ? "visible" : "hidden" }}
                    >
                        Cancel Selected
                    </Button>
                </Col>
                <Col span={2.5}>
                    <Button
                        type="danger"
                        onClick={() => this.setState({ showDeleteModal: true })}
                        disabled={!this.atleastOneSelected()}
                        style={{ visibility: this.atleastOneSelected() ? "visible" : "hidden" }}
                    >
                        Delete Selected
                    </Button>
                </Col>

                {this.state.showDeleteModal ?
                    <PatientFolderDeleteModal
                        folders={this.props.selectedRows}
                        closeModal={() => this.setState({ showDeleteModal: false })}
                    />
                    : <></>
                }
            </Row>
        )
    }
}

export default PatientFolderActions